
import facadeRef1 from "@/assets/facade-ref-1.jpg";
import facadeRef2 from "@/assets/facade-ref-2.webp";
import facadeRef3 from "@/assets/facade-ref-3.png";

const projects = [
  {
    image: facadeRef1,
    alt: "Fassadensanierung Herford-Diebrock",
    caption: "Fassadensanierung in Herford-Diebrock"
  },
  {
    image: facadeRef2,
    alt: "Fassadencheck in Hiddenhausen",
    caption: "WDVS-Projekt in Hiddenhausen"
  },
  {
    image: facadeRef3,
    alt: "Innendämmung Enger",
    caption: "Innendämmung in Enger"
  }
];

const areas = [
  "Herford", "Hiddenhausen", "Enger", "Löhne", "Bünde", 
  "Kirchlengern", "Vlotho", "Spenge", "Rödinghausen",
  "Extertal", "Dörentrup", "Kalletal", "Lemgo", "Lage",
  "Leopoldshöhe", "Oerlinghausen", "Bad Salzuflen", "Detmold",
  "Bielefeld", "Melle", "Bad Oeynhausen"
];

export const LocalRelevance = () => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-background">
      <div className="container mx-auto">
        <div className="max-w-3xl mb-10 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4 block">
            Regional verwurzelt
          </span>
          <h2 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-foreground">
            Ihr Malermeister für Herford, Hiddenhausen & Löhne
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Wir kennen die Architektur und die energetischen Herausforderungen im Kreis Herford. 
            Mit Leidenschaft und Know-how verwandeln wir Ihr Zuhause in eine Wohlfühl-Oase.
          </p>
        </div>

        {/* Project Gallery */}
        <div className="grid md:grid-cols-3 gap-4 mb-12">
          {projects.map((project, index) => (
            <div key={index} className="group relative rounded-xl overflow-hidden aspect-[4/3]">
              <img 
                src={project.image} 
                alt={project.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          ))}
        </div>

        {/* Service Areas */}
        <div className="flex flex-wrap items-center justify-center gap-2">
          {areas.map((area) => (
            <span 
              key={area} 
              className="px-3 py-1.5 bg-muted rounded-md text-xs font-medium text-foreground"
            >
              {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
